import { vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "b-fixed-background",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideFixedBg && _ctx.hideFixedBg(...args)))
  }, null, 512)), [
    [_vShow, _ctx.isFixedBg]
  ])
}